/* eslint-disable import/no-anonymous-default-export */
export default {
  addPOBtnLabel: "Add PO",
  viewProcurementOfficerHeading: "عرض مسئول المشتريات",
  editProcurementOfficerHeading: "تحرير مسؤول المشتريات",
  addProcurementOfficerHeading: "إضافة مسئول مشتريات",
  name: "اسم مسئول المشتريات",
  deleteAlert: "هل أنت متأكد أنك تريد حذف مسؤول المشتريات هذا؟",
  nameError: "اسم موظف المشتريات مطلوب",
};
